// channelTypes.js

export const CHANNEL_TYPES = Object.freeze({
  TEXT: 'TEXT',
  VOICE_VIDEO: 'VOICE_VIDEO',
  CONVERSATION: 'CONVERSATION',
});

export const CONVERSATION_KINDS = Object.freeze({
  /** Wire value — do not rename without a persistence migration. */
  AI: 'orbital_ai',
});

const normalizeChannelTypeValue = (value) => String(value || '').trim().toUpperCase();

export const normalizeChannelType = (value) => {
  const normalized = normalizeChannelTypeValue(value);

  if (normalized === CHANNEL_TYPES.VOICE_VIDEO) {
    return CHANNEL_TYPES.VOICE_VIDEO;
  }

  if (normalized === CHANNEL_TYPES.CONVERSATION) {
    return CHANNEL_TYPES.CONVERSATION;
  }

  return CHANNEL_TYPES.TEXT;
};

export const isVoiceVideoChannel = (value) => normalizeChannelType(value) === CHANNEL_TYPES.VOICE_VIDEO;

export const isConversationChannel = (value) => normalizeChannelType(value) === CHANNEL_TYPES.CONVERSATION;

export const isAiConversation = (channel) => (
  isConversationChannel(channel?.channelType)
  && String(channel?.conversationKind || '').trim() === CONVERSATION_KINDS.AI
);

export const isTextChannel = (value) => normalizeChannelType(value) === CHANNEL_TYPES.TEXT;

export const isThreadableChannel = (value) => {
  if (isConversationChannel(value) || isVoiceVideoChannel(value)) return false;
  return true;
};

export const supportsChannelThreads = (channel) => {
  if (isAiConversation(channel)) return true;
  return isThreadableChannel(channel?.channelType);
};

export const isTopicChannel = (value) => {
  const normalized = normalizeChannelType(value);
  return normalized === CHANNEL_TYPES.TEXT || normalized === CHANNEL_TYPES.VOICE_VIDEO;
};

export const getChannelTypeLabel = (value) => {
  if (isVoiceVideoChannel(value)) {
    return 'Voice / Video';
  }

  if (isConversationChannel(value)) {
    return 'Conversation';
  }

  return 'Text Channel';
};
